import { useTranslation } from "react-i18next";

const OPTIONS = [
  { val: true, key: "app.yes", tag: "yes" },
  { val: false, key: "app.no", tag: "no" },
  { val: null, key: "branches.inherit", tag: "inherit" },
];

// ثلاثي الحالة: نعم / لا / غير محدّد (يتبع الشركة).
export const TriToggle = ({ label, value, onChange, testId }) => {
  const { t } = useTranslation();
  const current = value === undefined ? null : value;
  return (
    <div>
      <p className="label-xs mb-2">{label}</p>
      <div className="flex gap-2">
        {OPTIONS.map((o) => (
          <button
            key={o.tag}
            type="button"
            data-testid={`${testId}-${o.tag}`}
            onClick={() => onChange(o.val)}
            className={`rounded-2xl bg-background px-4 py-2 text-xs font-bold transition-[box-shadow,color] duration-300 ${
              current === o.val
                ? "text-primary shadow-neu-in"
                : "text-muted-foreground shadow-neu-sm hover:text-foreground"
            }`}
          >
            {t(o.key)}
          </button>
        ))}
      </div>
    </div>
  );
};
